
<div id="recaptcha-container"></div>
<div class="otp-container" *ngIf="showOtpForm">
  <mat-card class="otp-card">
    <mat-card-header>
      <div class="header-text">
        <mat-card-title>Phone Number Verification</mat-card-title>
        <mat-card-subtitle>Secure your account with a One-Time Password (OTP)</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content class="otp-content">
      <!-- OTP Verification Form - Now shows immediately -->
      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()" class="otp-form">
        <!-- Show loading message while sending OTP -->
        <div *ngIf="!otpSent && requestInProgress" class="sending-message">
          <mat-spinner diameter="30"></mat-spinner>
          <p>Sending verification code to {{ otpForm.get('phoneNumber')?.value }}...</p>
        </div>

        <!-- Show OTP input after code is sent -->
        <div *ngIf="otpSent">
          <mat-form-field appearance="outline" floatLabel="always" class="full-width-input">
            <mat-label>Enter Code</mat-label>
            <input matInput formControlName="otp" placeholder="Enter the code we sent to your phone" type="text" #otpInput>
            <mat-error *ngIf="otpForm.get('otp')?.hasError('required')">Code is required</mat-error>
            <mat-error *ngIf="otpForm.get('otp')?.hasError('minlength') || otpForm.get('otp')?.hasError('maxlength')">Code must be 6 digits</mat-error>
            <mat-hint>Code sent to {{ otpForm.get('phoneNumber')?.value }}</mat-hint>
          </mat-form-field>
          <div class="button-group">
            <button mat-stroked-button type="button" (click)="cancelOtp()">Back</button>
            <button mat-raised-button color="primary" type="submit" [disabled]="requestInProgress || otpForm.get('otp')?.invalid">Verify Code</button>
          </div>
          <p *ngIf="otpVerificationFailed" class="resend-otp">Verification failed. <a *ngIf="canSendOtp" (click)="resendOtp()">Resend Code</a></p>
          <p *ngIf="otpVerificationFailed && !canSendOtp" class="resend-otp-timer">Resend available in {{ timeLeft }} seconds.</p>
          <p *ngIf="!otpVerificationFailed && canSendOtp && otpSent" class="resend-otp">Didn't receive the code? <a (click)="resendOtp()">Resend Code</a></p>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="requestInProgress"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>
</div>
